module.exports = __webpack_public_path__ + "img/service-circle-2.c47af242.png";